export default {
  _travel_policy_mode: {
    default: "Mode de traitement de la politique de voyage",
    values: {
      null: "Non défini",
      0: "@:travelPolicy.mode.0",
      10: "@:travelPolicy.mode.10",
      20: "@:travelPolicy.mode.20",
      30: "@:travelPolicy.mode.30"
    }
  },
  travelPolicy: {
    default: "Politique de voyage",
    add: "Ajouter une politique de voyage",
    selected:"Politiques de voyage appliquées",
    definition: {
      title: "Définition du mode et des prix par défaut",
      mode: "Mode",
      prices: "Prix par défaut"
    },
    price: {
      room: "Prix par chambre (petit-déjeuner inclus)",
      no_breakfast: "Prix sans petit-déjeuner",
      roomSplit: {
        1: "Prix chambre",
        2: "Petit-déjeuner inclus"
      },
      evening: "Prix soirée étape",
      meal: "Prix repas",
    },
    mode: {
      default: "Mode",
      0: "Inactif",
      10: "Informatif",
      20: "Soumis à validation",
      30: "Impossible",
      front: {
        0: "Aucune politique de voyage n'est définie.",
        10: "Les offres dépassant les montants indiqués ci-dessous font état d'une mention à titre informatif.",
        20: "Les offres dépassant les montants indiqués ci-dessous sont soumises à validation par un manager",
        30: "Les offres dépassant les montants indiqués ci-dessous ne sont pas accessible."
      }
    },
    dates: {
      title: "Intervalle de dates",
      start: "Date de début",
      end: "Date de fin",
      format: "DD/MM"
    },
    alert: {
      def: {
        success: "Action effectuée avec succès",
        danger: "Une erreur est survenue."
      },
      add: {
        success: "Action effectuée avec succès",
        danger: "Une erreur est survenue"
      }
    }
  },
  sector: {
    type: {
      region: "Région",
      department: "Département",
      city: "Ville",
      zone: "Zone",
      other: "Autre"
    }
  }
}
